// Подписи и вердикты по целям — чистые функции, общие для «Цели» и «Сегодня».

import { formatDate, formatNumber } from '@/lib/format'

import type { Goal, GoalKind } from './api'

export const KIND_OPTIONS: { value: GoalKind; label: string; unit: string }[] = [
  { value: 'weight', label: 'Вес к дате', unit: 'кг' },
  { value: 'steps', label: 'Шаги в день', unit: 'шагов' },
  { value: 'sleep', label: 'Сон', unit: 'ч' },
  { value: 'workouts_per_week', label: 'Тренировок в неделю', unit: 'раз' },
  { value: 'exercise_weight', label: 'Вес в упражнении', unit: 'кг' },
  { value: 'body_fat_pct', label: 'Жир, %', unit: '%' },
  { value: 'fat_mass_kg', label: 'Жир, кг', unit: 'кг' },
]

export type Verdict = { text: string; tone: 'accent' | 'warning' | 'neutral' } | null

/** «По графику» / «Отстаёшь» — только для цели с датой и известным прогрессом. */
export function goalVerdict(goal: Goal): Verdict {
  const p = goal.progress
  if (p.reached) return { text: 'Достигнута', tone: 'accent' }
  if (p.on_track === true) return { text: 'По графику', tone: 'accent' }
  if (p.on_track === false) return { text: 'Отстаёшь', tone: 'warning' }
  return null
}

export function goalNumbers(goal: Goal): string {
  const p = goal.progress
  const unit = goal.unit
  const current = p.current === null ? '—' : formatNumber(p.current, { digits: 1 })
  return `${current} из ${formatNumber(goal.target_value, { digits: 1 })} ${unit}`
}

export function goalDeadline(goal: Goal): string | null {
  if (!goal.target_date) return null
  const left = goal.progress.days_left
  const tail = left === null ? '' : left >= 0 ? ` · осталось ${left} дн.` : ' · срок вышел'
  return `к ${formatDate(goal.target_date)}${tail}`
}

export type GoalPrefill = { kind: GoalKind; target: string; start: string }

/** Значения формы цели из адреса `/teloscope/goals?new=1&kind=…&target=…&start=…`; без `new=1` или с чужим видом — null. */
export function initialGoalForm(params: URLSearchParams): GoalPrefill | null {
  if (params.get('new') !== '1') return null
  const kind = KIND_OPTIONS.find((o) => o.value === params.get('kind'))?.value
  if (!kind) return null
  return { kind, target: params.get('target') ?? '', start: params.get('start') ?? '' }
}
